const state = { all: {} };
const getters = {
  /* Partially Implemented not for production use */
  user: (state) => state,
};
import { apiService } from "@/_services";

const actions = {
  async getAll({ commit }) {
    let params = {
      method: "GET",
      endpoint: "user",
      content_type: "application/json",
      query_params: {
        format: "json",
      },
    };
    commit("getAllRequest");
    try {
      const data = await apiService.getAll(params);
      // A missing/empty payload here means the profile never loaded.
      if (!data || typeof data !== "object") {
        throw new Error("User profile could not be loaded.");
      }
      Object.assign(data, {
        habeas_data: Boolean(data.habeas_data),
      });
      commit("getAllSuccess", data);
      return data;
    } catch (error) {
      commit("getAllFailure", error);
      throw error;
    }
  },
  logout({ commit }) {
    commit("logout");
  },
};

const mutations = {
  getAllRequest(state) {
    state.all = { loading: true };
    // state.all = { items: user };
  },
  getAllSuccess(state, user) {
    // console.log("user");
    // console.log(user);
    localStorage.setItem("userData", user.pk_idusers);
    state.all = { items: user };
  },
  getAllFailure(state, error) {
    state.all = { error };
  },
  logout(state) {
    state.all = null;
  },
};

export const user = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
